import useEntities from 'hooks/useEntities';
import { entityColumnsToAntColumns } from 'utils/entityColumnsToAntColumns';
import HmsTableWithFilters from 'components/HmsTableWithFilters';

const GroupPhases = ({ sourceEntityId: id, data: childrenData }) => {
    const entities = useEntities();
    const childEntity = entities.Phase;

    return (
        <HmsTableWithFilters
            exportEnabled={true}
            layoutType='plain'
            createButtonLink={`/phases/_new_?parentId=${id}`}
            onRowClickedLink={(record) => childEntity.entityUrl(record)}
            columns={entityColumnsToAntColumns(childEntity, [
                'name',
                'nick',
                'short',
                'tournamentType',
                'startDate',
                'endDate',
                'status',
            ])}
            data={childrenData}
        />
    )
}

export default GroupPhases
